var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOdometer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.667 0a6.666 6.666 0 1 1 0 13.333A6.666 6.666 0 0 1 6.667 0Zm0 1.333a5.334 5.334 0 1 0 0 10.667 5.334 5.334 0 0 0 0-10.667Zm3.064 2.27c.136.136.153.35.042.506C8.319 6.14 7.519 7.228 7.374 7.374a1.002 1.002 0 0 1-1.415-1.415c.25-.248 1.337-1.049 3.263-2.401a.397.397 0 0 1 .509.045ZM10.333 6a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334ZM3 6a.667.667 0 1 1 0 1.334A.667.667 0 0 1 3 6Zm1.545-2.397a.667.667 0 1 1-.944.942.667.667 0 0 1 .944-.942Zm2.122-1.27a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334Z",
  fill: "currentColor"
})));
export { SvgOdometer as ReactComponent };
export default __webpack_public_path__ + "static/media/9e6868df.svg";